/**
 * M15 - report what the Content-Security-Policy blocks.
 *
 * The policy lives in a <meta> tag (the HTML document is served by the platform's
 * static server, which the app cannot set headers on), and a meta policy cannot
 * carry `report-uri` / `report-to` - browsers ignore those there. So the page
 * reports for itself: every violation is summarised and posted to
 * `/api/security/csp-report`, where the backend logs it.
 *
 * Deliberately quiet: deduplicated by directive + blocked URL, capped per page
 * load, and failures are swallowed. A security telemetry helper must never be
 * the reason a screen breaks.
 */
const ENDPOINT = `${process.env.REACT_APP_BACKEND_URL}/api/security/csp-report`;
const MAX_REPORTS = 10;

const seen = new Set();
let sent = 0;

window.addEventListener('securitypolicyviolation', (event) => {
  try {
    const directive = event.effectiveDirective || event.violatedDirective || '';
    const blocked = event.blockedURI || '';
    const key = `${directive}|${blocked}`;
    if (seen.has(key) || sent >= MAX_REPORTS) return;
    seen.add(key);
    sent += 1;

    const body = JSON.stringify({
      'effective-directive': directive,
      'blocked-uri': blocked,
      'document-uri': event.documentURI || window.location.href,
      'source-file': event.sourceFile || '',
      'line-number': event.lineNumber || 0,
    });

    if (navigator.sendBeacon) {
      navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch (e) {
    /* telemetry must never break the page */
  }
});
